import { format, isBefore, startOfDay } from 'date-fns';
import type { StudentSchedulingDetails } from '../api/getStudentsSchedulingDetails';
import { enrollmentDateToCenterDay } from './enrollmentDateToLocalDay';
import { getStudentEnrollmentDetails } from './getStudentEnrollmentDetails';

export const getStudentRemainingSessions = (
  studentsSchedulingDetails: StudentSchedulingDetails[],
  studentId: number,
  enrollmentId: number,
  date: Date,
  timeZone: string,
) => {
  const enrollment = getStudentEnrollmentDetails(studentsSchedulingDetails, studentId, enrollmentId);

  if (!enrollment) return 0;

  if (enrollment.type === 'FLEXIBLE') {
    const enrollmentEndDay = enrollmentDateToCenterDay(enrollment.enrollmentEndDate, timeZone);

    return enrollmentEndDay && isBefore(enrollmentEndDay, startOfDay(date)) ? 0 : Infinity;
  }

  const remainingSessions = enrollment.remainingSessions;

  if (remainingSessions.packageSessions) {
    return remainingSessions.packageSessions.remainingCount;
  }

  if (remainingSessions.monthlySessions) {
    const monthKey = format(date, 'MM/yyyy');

    return remainingSessions.monthlySessions.find((element) => element.month === monthKey)?.remainingCount ?? 0;
  }

  return 0;
};
